<div class="system-audit-log">
    <res-generic-grid [gridName]="gridName" [automationId]="automationId" [columnDefs]="columnDefs"
        [requestInfo]="requestInfo" [headerTemplate]="activeUserHeaderTemplate" [gridContext]="gridContext"
        [(isBusy)]="isGridBusy" [(isBusyMessage)]="isGridBusyMessage"
        [responseCallback]="responseCallback" isGridWithDurationColumn='true' [pagerTemplate]="pagerWithDownloadTemplate">
    </res-generic-grid>

    <ng-template #pagerWithDownloadTemplate>
        <button type="button" [attr.data-automation-id]="automationId + '-download-button'"
            class="secondary-button icon-button borderless-button" (click)="downloadSystemAuditLog()"
            [title]="downloadTooltip">
            <i class="fa fa-download color-blue-01"></i>
        </button>
    </ng-template>

    <ng-template #activeUserHeaderTemplate>
        <div class='top-bar-container'>
            <span class="title">System Audit Log</span>
            <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
                (click)="openHelp()">
                <i class="fa fa-question"></i>
            </button>
        </div>
    </ng-template>
<a download #downloadLink hidden target="_blank"></a>
</div>